/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Loading_StampsInputs */

const cs_import_feed_loading_stamps = /** @type {(inputs: Import_Feed_Loading_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozšiřuji seznam nabídek — u velkých feedů to může trvat několik minut…`)
};

const en_import_feed_loading_stamps = /** @type {(inputs: Import_Feed_Loading_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expanding the offer list — this can take a few minutes for large feeds…`)
};

/**
* | output |
* | --- |
* | "Expanding the offer list — this can take a few minutes for large feeds…" |
*
* @param {Import_Feed_Loading_StampsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_loading_stamps = /** @type {((inputs?: Import_Feed_Loading_StampsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Loading_StampsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_loading_stamps(inputs)
	return cs_import_feed_loading_stamps(inputs)
});